import { createContext } from 'react';

import { ApplicationContext } from '@upside/spa-shared-context';

export const AppContext = createContext<ApplicationContext | undefined>(
  undefined,
);
